import type { FaireProductEntity } from "../../entity_types/product";

export const p_1oldmyfr1b: FaireProductEntity = {
  token: "p_1oldmyfr1b",
  type: "product",
  name: "Iodine Complex Liquid",
  brandToken: "b_dv7rbrma47",
  brandName: "Maxi Health",
  imageUrl:
    "https://cdn.faire.com/fastly/862d6ba4b0113b108bba75d03de7bc880a3162ee073ad600ffbb80b6b5ecb9db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3f1b330ffa91cb827b6ee197a03cbedd94c54dd02984b1ba111c4d7e25791a9.jpeg",
    "https://cdn.faire.com/fastly/635906fc161f9da76593c882209e2b12e13306b8ae4e7b80a8f20c82b2e79aac.jpeg",
  ],
  priceDollars: 24.07,
  description:
    "Iodine is so difficult to get predictably from our diets. What to do Maxi Health Research® has the answer! Try our Liquid Iodine Complex. All the benefits of iodine are a drop away!\nIodine (as potassium iodide) is needed for the healthy function of the thyroid gland.\nKelp is high in natural iodine.\nPotassium Iodide while not a shield against radiation hazards, does prevent the thyroid from accepting iodine which is radioactive.\nSize: 2 Floz.",
  tags: [],
  msrpDollars: 40.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:14.909Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
